import { createContext } from "react";

const CursosFavoritosContext = createContext();

export default CursosFavoritosContext;
